module.exports = __webpack_public_path__ + "static/atts-42ddb79b7b769b17bda1f13d18fcb693.png";